import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useDisclaimerStyles = makeStyles((theme: Theme) => {
  const isDark = theme.palette.mode === 'dark';

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },

    warningBox: {
      padding: '12px',
      borderRadius: '8px',
      border: isDark ? '1px solid #AF8508' : '1px solid #F4BF1F',
      background: isDark
        ? 'rgba(255, 195, 0, 0.08)'
        : 'rgba(255, 195, 0, 0.12)',
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
    },

    inlineRow: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
    },

    icon: {
      fontSize: 18,
      color: isDark ? '#FFC300' : '#DBA70B',
    },

    asterisk: {
      color: 'var(--xlrt-color-sun-red650)',
      fontWeight: 600,
    },

    text: {
      fontSize: '0.8rem',
      color: isDark ? '#fff' : '#35363A',
      lineHeight: 1.5,
    },

    title: {
      fontSize: '0.95rem',
      fontWeight: 600,
      marginBottom: 4,
    },

    subtitle: {
      fontSize: '0.875rem',
      // color: isDark ? '#ccc' : '#666',
      marginBottom: 8,
    },

    highlight: {
      fontSize: '0.875rem',
      fontWeight: 500,
      marginTop: 8,
    },

    readMore: {
      fontSize: '0.8rem',
      textDecoration: 'underline',
      cursor: 'pointer',
      width: 'fit-content',
      marginLeft: '26px',
    },

    expandedBox: {
      marginTop: '6px',
      marginLeft: '26px',
      padding: '10px',
      borderRadius: '6px',
      background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.6)',
      border: '1px solid rgba(0,0,0,0.08)',
      maxHeight: 220,
      overflowY: 'auto',
    },

    checkbox: {
      marginLeft: '6px',
    },

    checkboxLabel: {
      fontSize: '0.875rem',
    },

    errorBox: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '2px',
    },

    errorIcon: {
      color: 'var(--xlrt-color-sun-red650)',
      fontSize: '20px',
    },

    errorText: {
      color: 'var(--xlrt-color-sun-red650)',
      fontSize: '0.875rem',
    },

    inlineButtonBox: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
  };
});
